// TIP 这里定义所有  获取本地state  方法的名称，即定义mutations中方法的名称

// FIXME 此处，尝试  首字母大写，其它字母小写，下划线分词  的写法。
export const getterTypes = {
  Getter_User_Name: 'Getter_User_Name', // 获取，用户名称。
  Getter_Token: 'Getter_Token', // 获取，Token凭证。
  Getter_Lang: 'Getter_Lang', // 获取，Lang使用语言。
  Getter_Langs_List: 'Getter_Langs_List', // 获取，所有语言，列表
  Getter_Assets_List: 'Getter_Assets_List',
  Getter_ExpireTime: 'Getter_ExpireTime', // 获取，过期时间
  Getter_LastUpdateTime: 'Getter_LastUpdateTime', // 获取，最后更新时间
  Getter_Market_List: 'Getter_Market_List', // 获取，所有的交易市场。
  Getter_Current_Market: 'Getter_Current_Market', // 获取，当前所在的交易市场。
  Getter_User_Info: 'Getter_User_Info', // 获取，用户的信息对象。
  Getter_User_Vip: 'Getter_User_Vip',
  Getter_Current_Currency: 'Getter_Current_Currency', // 获取，当前所在的货币类型。
  Getter_Currencies_List: 'Getter_Currencies_List', // 获取，所有的货币类型。
  Getter_All_Coin: 'Getter_All_Coin',
  Getter_Unread_Message_Count: 'Getter_Unread_Message_Count', // 获取，未读消息的数量。
  Getter_Information_Nav: 'Getter_Information_Nav', // 获取，资讯研究的二级导航。
  Getter_Socket_ConnectStatus: 'Getter_Socket_ConnectStatus', // 获取，Socket连接状态。
  Getter_Coin_List: 'Getter_Coin_List', // 获取，所有币种，列表
  GET_SLIDERMENU_CONTROLS: 'GET_SLIDERMENU_CONTROLS', // 获取移动端左侧菜单显示状态
  Getter_Trading_Pairs_List: 'Getter_Trading_Pairs_List', // 获取，所有币币交易对，列表
  Getter_CollectedMarketSymbols: 'Getter_CollectedMarketSymbols', // 获取，收藏的交易对id列表
  Getter_For_Mobile: 'Getter_For_Mobile', // For Mobile App to use
  Getter_Socket_State: 'Getter_Socket_State', // Socket state
  Getter_Burger_Menu_State: 'Getter_Burger_Menu_State', // Burger menu state
  Getter_Wechat_QRCode_State: 'Getter_Wechat_QRCode_State', // wechat qr code
  GETTER_AFFILIATE_PARTNER_INFO: 'GETTER_AFFILIATE_PARTNER_INFO',
  GETTER_PARTNER_INFO: 'GETTER_PARTNER_INFO',
  GETTER_PARTNER_TYPE: 'GETTER_PARTNER_TYPE',
  GETTER_AFFILIATE_TYPE: 'GETTER_AFFILIATE_TYPE',

  GETTER_REWARD_CATEGORIES: 'GETTER_REWARD_CATEGORIES',
};
